
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface UsersFilterProps {
  filter: string;
  onFilterChange: (value: string) => void;
}

export function UsersFilter({ filter, onFilterChange }: UsersFilterProps) {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
      <Input
        placeholder="Pesquisar usuários..."
        value={filter}
        onChange={(e) => onFilterChange(e.target.value)}
        className="pl-10"
      />
    </div>
  );
}
